import FaqComponent from '../components/faq/faq'

const Faq = () => <FaqComponent />

export default Faq;